<template>
  <v-menu v-model="menu" open-on-hover open-on-focus>
    <template v-slot:activator="{ on, attrs }">
      <v-autocomplete
        color="primary"
        hide-no-data
        v-model="cloudPrintersSelected"
        clearable
        chips
        multiple
        deletable-chips
        small-chips
        :items="cloudPrintersSelected"
        :loading="cloudPrintersLoading"
        :search-input.sync="cloudPrintersSearch"
        item-text="remark"
        item-value="id"
        :label="$t('cloudPrinterSetting.ObjectName')"
        return-object
        v-bind="attrs"
        v-on="on"
        @focus="cloudPrintersSearch = ''"
      >
        <template v-slot:append>
          <v-icon
            style="height: 24px; width: 24px"
            :color="menu ? 'primary' : ''"
            @click.stop="menu = !menu"
          >
            {{ menu ? "fa-caret-up" : "fa-caret-down" }}
          </v-icon>
        </template>
        <template v-slot:selection="data">
          <v-chip
            v-bind="data.attrs"
            small
            :input-value="data.selected"
            close
            @click:close="remove(data.item)"
          >
            {{ data.item.remark }}
          </v-chip>
        </template>
      </v-autocomplete>
    </template>
    <div style="max-height: 304px">
      <v-sheet>
        <v-treeview
          v-model="cloudPrintersSelected"
          :items="cloudPrinters"
          :search="cloudPrintersSearch"
          :filter="printersFilter"
          selection-type="independent"
          item-key="id"
          item-text="remark"
          item-children="show_categories"
          open-all
          selectable
          selected-color="primary"
          hoverable
          return-object
        />
      </v-sheet>
    </div>
  </v-menu>
</template>

<style scoped>
.v-list {
  display: none !important;
}
.v-menu__content {
  margin-top: 45px;
}
</style>

<script>
import CloudPrints from "@/api/cloud_prints";

export default {
  name: "SearcherCloudPrinters",

  props: {
    value: Array,
    noLabel: Boolean,
  },

  computed: {
    printersFilter() {
      return (item, search, textKey) => item[textKey].indexOf(search) > -1;
    },
  },

  created() {
    this.getCloudPrintersFromAPI();
  },

  data: () => ({
    menu: false,
    cloudPrinters: [],
    cloudPrintersLoading: false,
    cloudPrintersSearch: "",
    cloudPrintersSelected: [],
  }),

  methods: {
    remove(item) {
      const index = this.cloudPrintersSelected.indexOf(item);
      if (index >= 0) this.cloudPrintersSelected.splice(index, 1);
    },
    getCloudPrintersFromAPI() {
      this.cloudPrintersLoading = true;
      CloudPrints.fetch()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.cloudPrinters = response.data.cloud_prints;
            }
            this.cloudPrintersLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.cloudPrintersLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.cloudPrintersSelected = this.value ? this.value : [];
      },
    },
    cloudPrintersSelected: {
      handler() {
        this.$emit("input", this.cloudPrintersSelected);
      },
    },
  },
};
</script>
